@if (showDot()) {
  <div class="dot"></div>
}

@if (showEndsToday()) {
  <div class="bundle-ends-today-label">
    Endet heute
  </div>
} @else {
  <div class="bundle-action-label">
    @if (showActionLabel()) {
      <span>Aktion</span>
    }

    @if (validFrom()) {
      <span> vom </span>
      <span class="label-date">{{ validFrom() | luxonDate: 'dd.MM' }}.</span>
    }

    @if (validTo()) {
      @if (showDaysLeft()) {
        <span> Noch </span>
      } @else {
        @switch (bundleType()) {
          @case ('advantage') {
            <span> » Vorteil bis </span>
          }
          @case ('reimbursement') {
            <span> » Vergütung bis </span>
          }
          @default {
            <span> bis </span>
          }
        }
      }

      @if (showDaysLeft()) {
        <span class="label-date">{{ remainingDays() }}
          @if (remainingDays() === 1) {
            Tag
          } @else {
            Tage
          }
        </span>
      } @else {
        <span class="label-date">{{ validTo() | luxonDate }}</span>
      }
    }
  </div>
}
